module.exports = __webpack_public_path__ + "img/26.4cb72f37.jpg";